// extracted by mini-css-extract-plugin
module.exports = {"container":"Events_diet_container__2zOKs","item":"Events_diet_item__2jPYq"};